import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
@Component({
  selector: 'ngx-modal-detalhes-extrato',
  templateUrl: './modal-detalhes-extrato.component.html',
  styleUrls: ['./modal-detalhes-extrato.component.scss'],
})
export class ModalDetalhesExtratoComponent implements OnInit {


  @Input() dataAutorizacao: string;
  @Input() descricao: string;
  @Input() valor: string;
  @Input() valorTarifa: string;
  @Input() estabelecimentoNome: string;

  @ViewChild('card', null)
  private card: ElementRef;

  public formDetalhesExtrato = null;
  public isDisabledSaveButton: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    protected ref: NbDialogRef<ModalDetalhesExtratoComponent>,

  ) { }

  ngOnInit() {
    this.formDetalhesExtrato = this.formBuilder.group({});
  }

  voltar() {
    this.ref.close();
  }

}
